import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
// import StatementDocument from "./StatementDocument";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx"; // 1. Import XLSX
import OutstandingDocument from "./OutstandingDocument";

const OutstandingPreview = ({
  statementDataRecordsFromAPI,
  statementDataFromAPI,
  handleCloseStatement,
}) => {
  console.log("statementDataFromAPI", statementDataFromAPI)
  const location = useLocation();
  const navigate = useNavigate();

  const [statementData, setStatementData] = useState([]);
  const [statementDataFrom, setStatementDataFrom] = useState([]);
  const [statementDataTo, setStatementDataTo] = useState([]);

  useEffect(() => {
    if (location.state) {
      console.log(
        "location.state in Outstanding preview:",
        location.state.statementData.apiData,
      );
      setStatementData(location.state.statementData.apiData);
      setStatementDataFrom(location.state.statementData.apiData);
      setStatementDataTo();
    }
  }, [location]);

  const mainData = statementDataFromAPI || [];
  const apiData = statementDataFromAPI?.apiData || [];
  console.log("apiData", apiData)
  const agingData = statementDataFromAPI?.agingData[0] || [];
  // console.log("Statement data", apiData);
  // console.log("Statement mainData ACC", mainData?.apiData[0]?.ACCOUNT);
  // console.log("Statement mainData ACC DEC", mainData?.apiData[0]?.NAME);
  // console.log("agingData:", agingData);
  console.log("mainData:", mainData);

  const outstandingDataAccount = mainData?.apiData[0]?.ACCOUNT;
  const outstandingDataAccountName = mainData?.apiData[0]?.NAME;
  const outstandingDataAccountTRN = mainData?.apiData[0]?.TRN;

  // 2. Define the Excel Export Function
  const exportToExcel = () => {
    if (apiData.length === 0) {
      alert("No data available to export");
      return;
    }

    const formattedData = apiData.map((item) => {
      const row = { ...item };
      if (row?.INVDATE) {
        row.INVDATE = row?.INVDATE?.split("T")[0];
      }
      return row;
    });

    // Create a new workbook and worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Statement");

    // Generate buffer and trigger download
    XLSX.writeFile(workbook, "statement_export.xlsx");
  };

  const onBackToOutstanding = () => {
    navigate("/statements");
    handleCloseStatement();
  };

  // const rows = statementData || [];
  const rows = statementDataRecordsFromAPI || [];

  console.log("Rows :", rows);
  // Totals
  const totals = rows.reduce(
    (acc, r) => {
      acc.debit += Number(r.DEBIT || 0);
      acc.credit += Number(r.CREDIT || 0);
      acc.balance += Number(r.BALANCE || 0);
      return acc;
    },
    { debit: 0, credit: 0, balance: 0 },
  );

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center my-4">
        <h2 className="text-xl font-semibold">Statement Preview</h2>

        {/* Button Container */}
        <div className="flex gap-2">
          {/* 3. The Excel Button */}
          <button
            onClick={exportToExcel}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded transition-colors"
          >
            Export to Excel
          </button>

          <button
            className="text-white px-4 py-1 rounded bg-gray-800 hover:bg-black transition-colors"
            // onClick={handleCloseStatement}
            onClick={onBackToOutstanding}
          >
            Back
          </button>
        </div>
      </div>

      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-full border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <OutstandingDocument
              statementDataFromAPI={statementDataFromAPI}
              accountData={statementDataFromAPI}
              outstandingData={statementData}
              outstandingDataRecordsFromAPI={statementDataRecordsFromAPI}
              systemFromDate={statementData}
              systemToDate={statementData}
              totals={totals}
              outstandingDataAccount={outstandingDataAccount}
              outstandingDataAccountName={outstandingDataAccountName}
              outstandingDataAccountTRN={outstandingDataAccountTRN}
              agingData={agingData}
            />
          </PDFViewer>
        </div>

        <div className="mt-4 mb-12">
          <PDFDownloadLink
            document={
              <OutstandingDocument
                statementDataFromAPI={statementDataFromAPI}
                accountData={statementDataFromAPI}
                outstandingData={statementData}
                outstandingDataRecordsFromAPI={statementDataRecordsFromAPI}
                systemFromDate={statementData}
                systemToDate={statementData}
                totals={totals}
                outstandingDataAccount={outstandingDataAccount}
                outstandingDataAccountName={outstandingDataAccountName}
                outstandingDataAccountTRN={outstandingDataAccountTRN}
                agingData={agingData}
              />
            }
            fileName="outstanding-statement.pdf"
          >
            Download Outstanding PDF
          </PDFDownloadLink>
        </div>
      </div>
    </div>
  );
};

export default OutstandingPreview;
